import { render, staticRenderFns } from "./express-photo.vue?vue&type=template&id=05cfb290&scoped=true&"
import script from "./express-photo.vue?vue&type=script&lang=ts&"
export * from "./express-photo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfb290",
  null
  
)

export default component.exports